<template>
  <div class="store-performance">
    <OptionHeader :title="'全店铺绩效'" :filter="filter"  @refresh="refresh" />
    <div class="right-tool">
      <OptionGroup
          :show-list= "['refresh']"
          @refresh="refresh"
      />
    </div>
    <div class="store-performance-content">
      <gj-table
        :min-height="400"
        ref="gjTable"
        size='has-picture'
        :index="false"
        :loading="loading"
        :data="tableData"
        :columns="columns"
        :show-overflow="false"
        :default-sort="{prop: 'orderWithDefectRate', order: 'descending'}"
        @sort-change="$gjSortChange"
        @page-change="$gjNoticeQuery">
        <template v-slot:orderWithDefectRate="{ row }">
          <div class="normal" @click="pushDetails('#customer-service', row.marketId, row.countryCode)"
               :class="row.orderWithDefectRateTarget === false ? 'abnormal' : ''"> {{ row.orderWithDefectRate || 0 }}
          </div>
          <div> {{ row.orderWithDefectTimeStart | convertToDate }} - {{
              row.orderWithDefectTimeEnd | convertToDate
            }}
          </div>
        </template>
        <template v-slot:returnDissatisfactionRate="{ row }">
          <div class="normal" @click="pushDetails('#customer-service', row.marketId, row.countryCode)"
               :class="row.returnDissatisfactionRateTarget === false ? 'abnormal' : ''">
            {{ row.returnDissatisfactionRate || 0 }}
          </div>
          <div> {{ row.returnDissatisfactionTimeStart | convertToDate }} -
            {{ row.returnDissatisfactionTimeEnd | convertToDate }}
          </div>
        </template>
        <template v-slot:validTrackingRate="{ row }">
          <div class="normal" @click="pushDetails('#distribution-performance', row.marketId, row.countryCode)"
               :class="row.validTrackingRateTarget === false ? 'abnormal' : ''"> {{ row.validTrackingRate || 0 }}
          </div>
          <div> {{ row.validTrackingTimeStart | convertToDate }} - {{ row.validTrackingTimeEnd | convertToDate }}</div>
        </template>
        <template v-slot:preFulfillmentCancellationRate="{ row }">
          <div class="normal" @click="pushDetails('#distribution-performance', row.marketId, row.countryCode)"
               :class="row.preFulfillmentCancellationRateTarget === false ? 'abnormal' : ''">
            {{ row.preFulfillmentCancellationRate || 0 }}
          </div>
          <div> {{ row.preFulfillmentCancellationTimeStart | convertToDate }} -
            {{ row.preFulfillmentCancellationTimeEnd | convertToDate }}
          </div>
        </template>
        <template v-slot:lateShipmentRate="{ row }">
          <div class="normal" @click="pushDetails('#distribution-performance', row.marketId, row.countryCode)"
               :class="row.lateShipmentRateTarget === false ? 'abnormal' : ''"> {{ row.lateShipmentRate || 0 }}
          </div>
          <div> {{ row.lateShipmentTimeStart | convertToDate }} - {{ row.lateShipmentTimeEnd | convertToDate }}</div>
        </template>
        <template v-slot:commodityPolicyDefect="{ row }">
          <div class="normal" @click="pushDetails('#product-compliance', row.marketId, row.countryCode)"
               :class="row.commodityPolicyDefectTarget === false ? 'abnormal' : ''">
            {{ row.commodityPolicyDefect || 0 }}
          </div>
        </template>
      </gj-table>
    </div>
  </div>
</template>

<script>
import {isMeaningfulMixin, queryMixin, selectionMixin} from "@/minxins";
import OptionHeader from "@/views/components/option-header/option-header"
import { performance } from "@/api/statistics";
import {convertToDate} from "@/utils/date.util.js"
import OptionGroup from "@/views/components/option-panel-group/option-group"

export default {
  name: "review-analysis",
  components: {OptionHeader,OptionGroup},
  mixins: [queryMixin, selectionMixin, isMeaningfulMixin],
  inject: ['getPageParams'],
  filters: {
    convertToDate(val) {
      if (!val) {
        return ""
      }
      return convertToDate(new Date(val))
    }
  },

  data() {
    return {
      useCache: false,
      loading: false,
      tableData: [],
      updateTime: '',
      columns: [
        {id: 'marketName', header: '店铺名称', field: 'marketName', minWidth: '120px', default: true},
        {
          id: 'orderWithDefectRate',
          header: '订单缺陷率(<1%)',
          field: 'slot:orderWithDefectRate',
          minWidth: '140px',
          default: true,
          disabled: true,
          sortable: true
        },
        {
          id: 'returnDissatisfactionRate',
          header: '退货不满意率(<10%)',
          field: 'slot:returnDissatisfactionRate',
          minWidth: '160px',
          default: true,
          disabled: true,
          sortable: true
        },
        {
          id: 'validTrackingRate',
          header: '有效追踪率(>95%)',
          field: 'slot:validTrackingRate',
          minWidth: '160px',
          default: true,
          sortable: true
        },
        {
          id: 'preFulfillmentCancellationRate',
          header: '订单取消率(<2.50%)',
          field: 'slot:preFulfillmentCancellationRate',
          minWidth: '160px',
          sortable: true
        },
        {
          id: 'lateShipmentRate',
          header: '延迟发货率(<4.00%)',
          field: 'slot:lateShipmentRate',
          minWidth: '160px',
          sortable: true
        },
        {
          id: 'commodityPolicyDefect',
          header: '商品政策合规性',
          field: 'slot:commodityPolicyDefect',
          minWidth: '120px',
          sortable: true
        },
      ],
    }
  },
  computed: {
    filter () {
      return this.getPageParams()
    }
  },
  mounted() {
    this.sort.prop = "orderWithDefectRate"
    this.$gjQuery()
  },
  methods: {
    // 获取数据
    performance() {
      let dataTime = convertToDate(new Date(), 'yyyy-MM-dd');
      this.loading = true
      let params = {
        dataTime: dataTime,
        countryCodes: this.filter?.countryMarketValue?.countryIds || [],
        marketIds: this.filter?.countryMarketValue?.marketIds || [],
        ...this.querySort
      }
      this.globalParams = params;
      performance(params).then(res => {
        this.tableData = res.dataList || [];
        this.loading = false
      }).complete(cb=>{this.loading=false})
    }, // 跳转详情
    pushDetails(anchorRoll, marketId, countryCode) {
      sessionStorage.setItem("anchorRoll", anchorRoll);
      this.$router.push({
        path: "/statistics/store-performance-details",
        query: {
          marketId,
          countryCode
        }
      })
    },
    // 查询
    $gjQuery() {
      this.performance()
    },
    refresh() {
      this.$gjQuery()
    }
  }
}
</script>

<style lang="scss"  scoped>
@import "../common/index.scss";

.store-performance {
  border-radius: 6px;
  background: white;
  margin-top: 20px;
  padding-right: 12px;
}

.store-performance-content {
  margin-top: 15px;
}
.normal {
  color: #2DA641;
  cursor: pointer;
}
.abnormal {
  color: #F5222D;
}
.right-tool{
  display: inline-block;
  float: right;
  margin-top: -24px;
}
</style>
